import React, {useEffect, useRef, useState} from 'react';
import {SafeAreaView, View} from 'react-native';
import ConferencePersonList from 'components/organisms/conferencePeopleList';
import {useTheme} from 'contexts/ThemeContext';
import styleSheet from './styles';
import {
  useClassStore,
  useConferenceStore,
  useUserStore,
} from 'contexts/StoreContext';
import {observer} from 'mobx-react';
import ConferenceBottomMenu from 'components/organisms/conferenceBottomMenu';
import ConferenceHeader from 'components/molecules/conferenceHeader';
import ReactionView, {
  AnimationReactionViewHandle,
} from 'components/molecules/animationReactionView';
import ChatList from 'components/organisms/chatList';
import ParticipantsList from 'components/organisms/participantsList';
import {ConferenceScreenProps} from 'navigations/HomeFlow';
import {Flows, ScreenName} from 'navigations/Screens';
import NavigationHeaderWeb from 'components/organisms/navigationWeb';

const ConferenceScreen = observer((props: ConferenceScreenProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const title = props.route.params.name;
  const classId = props.route.params.id;

  const reactionViewRef = useRef<AnimationReactionViewHandle>(null);

  const [isChatActive, setIsChatActive] = useState(false);
  const [isSmileActive, setIsSmileActive] = useState(false);
  const [isParticipantsActive, setIsParticipantsActive] = useState(false);
  const [isShareActive, setIsShareActive] = useState(false);
  const [
    isParticipantsHiddenWhileSharing,
    setIsParticipantsHiddenWhileSharing,
  ] = useState(false);

  const conferenceStore = useConferenceStore();
  const userStore = useUserStore();
  const chatStore = conferenceStore.chatStore;
  const classStore = useClassStore();

  useEffect(() => {
    console.log('props.route.params.id', props.route.params.id);

    conferenceStore.runConference(props.route.params.id);
    conferenceStore.onDisconnectCallback = onDisconnectButtonPressed;
  }, []);

  const onCameraButtonPressed = () => {
    conferenceStore.switchVideo();
  };

  const onMicrophoneButtonPressed = () => {
    conferenceStore.switchAudio();
  };

  const onChatButtonPressed = () => {
    if (theme.isWebSize) {
      chatStore.setIsChatListOpened(!isChatActive);
      setIsChatActive(!isChatActive);
      !isChatActive && setIsParticipantsActive(false);
    } else {
      props.navigation.navigate(ScreenName.chat);
    }
  };

  const onShareButtonPressed = async () => {
    if (isShareActive) {
      setIsShareActive(false);
      conferenceStore.stopShareScreen();
      return;
    }

    try {
      await conferenceStore.shareScreen();
      setIsShareActive(true);
    } catch (err) {}
  };

  const onSmileButtonPressed = () => {
    if (theme.isWebSize) {
      setIsSmileActive(!isSmileActive);
    } else {
      reactionViewRef.current?.show();
    }
  };

  const onDisconnectButtonPressed = () => {
    conferenceStore.disconnect();
    props.navigation.goBack();
  };

  const onPressShowHideParticipants = () => {
    setIsParticipantsHiddenWhileSharing(!isParticipantsHiddenWhileSharing);
  };

  const onPressStopShare = () => {
    setIsShareActive(false);
    conferenceStore.stopShareScreen();
  };

  const onMuteAllButtonPressed = () => {
    conferenceStore.muteAll();
  };

  const onUsersButtonPressed = () => {
    setIsParticipantsActive(!isParticipantsActive);
    !isParticipantsActive && setIsChatActive(false);
  };

  return (
    <SafeAreaView style={styles.flex}>
      <NavigationHeaderWeb activeName={Flows.homeFlow} />
      <View style={styles.container}>
        <View style={styles.flex}>
          <ConferenceHeader
            title={title}
            isParticipantsHidden={isParticipantsHiddenWhileSharing}
            isShowHideButtonShown={conferenceStore.isSharingActive}
            onPressBackButton={onDisconnectButtonPressed}
            onDisconnectButtonPressed={onDisconnectButtonPressed}
            onPressShowHideParticipants={onPressShowHideParticipants}
          />
          <ConferencePersonList
            isParticipantsHidden={isParticipantsHiddenWhileSharing}
            shareStream={conferenceStore.shareStream}
            streams={conferenceStore.streams}
          />
          <ConferenceBottomMenu
            isMicroActive={!!conferenceStore.myStream?.isAudioEnabled}
            isCameraActive={!!conferenceStore.myStream?.isVideoEnabled}
            isShareActive={isShareActive}
            isParticipantsActive={isParticipantsActive}
            isSmileActive={isSmileActive}
            isChatActive={isChatActive}
            shouldShowMuteAll={userStore.isTeacherOrAdmin}
            shouldShowUnreadMessageMarker={chatStore.hasUnreadMessages}
            onPressStopShare={onPressStopShare}
            onCameraButtonPressed={onCameraButtonPressed}
            onMicrophoneButtonPressed={onMicrophoneButtonPressed}
            onChatButtonPressed={onChatButtonPressed}
            onShareButtonPressed={onShareButtonPressed}
            onSmileButtonPressed={onSmileButtonPressed}
            onMuteAllButtonPressed={onMuteAllButtonPressed}
            onDisconnectButtonPressed={onDisconnectButtonPressed}
            onUsersButtonPressed={onUsersButtonPressed}
            onPressRaiseHand={conferenceStore.sendRaiseHand}
            onPressReaction={conferenceStore.sendReaction}
            onGetRecordingButtonPressed={() => classStore.getRecording(classId)}
            isRecordingRequest={classStore.isRecordingRequest}
          />
          {!theme.isWebSize && (
            <ReactionView
              ref={reactionViewRef}
              onPressRaiseHand={conferenceStore.sendRaiseHand}
              onPressReaction={conferenceStore.sendReaction}
            />
          )}
        </View>
        {theme.isWebSize && isChatActive && (
          <ChatList
            message={chatStore.message}
            setMessage={chatStore.setMessage}
            onPressSend={chatStore.sendMessage}
            chatMessages={chatStore.chatMessages}
          />
        )}
        {theme.isWebSize && isParticipantsActive && (
          <ParticipantsList users={conferenceStore.streams} />
        )}
      </View>
    </SafeAreaView>
  );
});

export default ConferenceScreen;
